export default "__VITE_ASSET__DkHVywjd__"